class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M13.002 14.5h-.085C3.093 13.935 1.697 5.645 1.503 3.115A1.5 1.5 0 0 1 2.882 1.5h2.756a1 1 0 0 1 .93.63L7.327 4a1 1 0 0 1-.22 1.08L6.043 6.155a4.685 4.685 0 0 0 3.79 3.8l1.085-1.075a1 1 0 0 1 1.085-.205l1.884.755a1 1 0 0 1 .615.93V13a1.5 1.5 0 0 1-1.5 1.5Zm-10-12a.5.5 0 0 0-.5.5v.04C2.732 6 4.207 13 12.973 13.5a.5.5 0 0 0 .53-.47v-2.67l-1.885-.755-1.435 1.425-.24-.03c-4.35-.545-4.94-4.895-4.94-4.94l-.03-.24 1.42-1.435-.75-1.885h-2.64Z"></path></svg>';
  }
}
const e = "pi-phone";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
